import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FieldNames from '../../../../defaults/FieldNames.json';
import DetailedFundingSources from '../../../../defaults/DetailedFundingSources.json';
import { useIFPRSGlobalContext } from '../../../../IFPRSGlobalContext';
import ErrorService from '../../../../services/ErrorService';
import LookupService from '../../../../services/LookupService';
import './SampleFilter.css';
import _, { get } from "lodash";
import ColorConstants from '../../../../defaults/ColorConstants';

const BlueAlien = "#1976d2";

export default function CheckboxFilter({userInfo, filter, setValue, value, postFireCategories, fuelsCategories, isPostFire=false}) {
  const dispatch = useDispatch();
  const [filterValues, setFilterValues] = useState([]);
  const { statusOptions, setStatusOptions, actionCategoryAssociations } = useIFPRSGlobalContext();
  const dataSet = useSelector((state) => state.filter.dataset);
  const config = useSelector((state) => state.configuration.config);
  const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);

  useEffect(() => {
    if(rootServiceUrl && config){
      if(!statusOptions || (statusOptions && statusOptions.length === 0)){
        LookupService.getStatuses(false).then(response => {
          if(response && response.length > 0){
            const statusNames = response.map(x => x[FieldNames.statusTable.status]);
            setStatusOptions(statusNames);
          }
        }).catch(error => {
          ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
        });
      }
    } 
  }, [rootServiceUrl, config, statusOptions, setStatusOptions]);

  useEffect(() => {
    const getCheckboxObject = (tempArray, values, isFilterPostFire) => {
      const finalCategoryTypes= _.cloneDeep(values)
      const sortedCategoryTypes = finalCategoryTypes?.sort((a, b) => a > b ? 1 : -1)
      if(sortedCategoryTypes && sortedCategoryTypes.length){
        sortedCategoryTypes.forEach(entry => {
          if(!finalCategoryTypes.includes(entry)){
            finalCategoryTypes.push(entry)
          }
        })
      }
      if(finalCategoryTypes && finalCategoryTypes.length > 0){
        finalCategoryTypes.forEach(element => {
          let isChecked = false;
          if (value && value.includes(element)) {
            isChecked = true;
          }
          const newItem = {
            name: element,
            code: element,
            isChecked: isChecked,
            isPostFire: isFilterPostFire
          }
          tempArray.push(newItem);
        })
      }
      return tempArray;
    }

    let tempArray = [];
    if(filter && filter.name === FieldNames.filterNamesWithCustomSetting.status){
      if(statusOptions && statusOptions.length > 0){
        statusOptions.forEach(element => {
          let isChecked = false;
          if (value && value.includes(element)) {
            isChecked = true;
          }
          const newItem = {
            name: element,
            code: element,
            isChecked: isChecked
          }
          tempArray.push(newItem);
        })
      }
    } else if(filter && filter.name === FieldNames.filterNamesWithCustomSetting.category){
      const postFireCategoryValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.postFire]?.[FieldNames.categoryAssociationFields.categories];
      const fuelsCategoryValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.fuels]?.[FieldNames.categoryAssociationFields.categories];
      if(dataSet === FieldNames.datasets.fuels){
        tempArray = getCheckboxObject(tempArray, fuelsCategoryValues, false)
      } else if(dataSet === FieldNames.datasets.postfire){
        tempArray = getCheckboxObject(tempArray, postFireCategoryValues, true)
      } else if(dataSet === FieldNames.datasets.both){
        tempArray = getCheckboxObject(tempArray, fuelsCategoryValues, false)
        tempArray = getCheckboxObject(tempArray, postFireCategoryValues, true)
      }
    } else if(filter && filter.name === FieldNames.filterNamesWithCustomSetting.type){
      const postFireTypeValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.postFire]?.[FieldNames.categoryAssociationFields.types];
      const fuelsTypeValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.fuels]?.[FieldNames.categoryAssociationFields.types];
      if(dataSet === FieldNames.datasets.fuels){
        tempArray = getCheckboxObject(tempArray, fuelsTypeValues, false)
      } else if(dataSet === FieldNames.datasets.postfire){
        tempArray = getCheckboxObject(tempArray, postFireTypeValues, true)
      } else if(dataSet === FieldNames.datasets.both){
        tempArray = getCheckboxObject(tempArray, fuelsTypeValues, false)
        tempArray = getCheckboxObject(tempArray, postFireTypeValues, true)
      }
    } else if(filter?.domain?.name === FieldNames.filterNamesWithCustomSetting.fundingSource) {
      let fundingValues = [];
      const fundingSources = DetailedFundingSources.fundingSources;
      if(fundingSources && fundingSources.length){
        fundingSources.forEach(entry => {
          if(!fundingValues.includes(entry[FieldNames.fundingSources.fundingSource])){
            fundingValues.push(entry[FieldNames.fundingSources.fundingSource])
          }
        })
      }
      if(fundingValues && fundingValues.length > 0){
        fundingValues.forEach(element => {
          let isChecked = false;
          if (value && value.includes(element)) {
            isChecked = true;
          }
          const newItem = {
            name: element,
            code: element,
            isChecked: isChecked
          }
          tempArray.push(newItem);
        })
      }
    } else {
      filter.domain?.codedValues.forEach(element => {
        let isChecked = false;
        if (value && value.includes(element.code)) {
          isChecked = true;
        }
        const newItem = {
          name: element.name,
          code: element.code,
          isChecked: isChecked
        }
        tempArray.push(newItem);
      });
    }
    setFilterValues(tempArray);
  }, [filter, value, statusOptions, actionCategoryAssociations, dataSet]);

  const checkboxChanged = (event, val) => {
    //setValue comes from redux in a parent file
    if (event.target.checked) 
    {
      let clone = [];
      if(value){
        clone = [...value];
      } 
      if(val){
        clone.push(val.code);
      }
      dispatch(setValue(clone));
      
    }
    else 
    {
      if (value && val && value.includes(val.code)) 
      {
        const clone = [...value];
        if(val){
          clone.splice(clone.indexOf(val.code), 1);
        }
        dispatch(setValue(clone));
      }
    }
  }

  const filterCheckboxes = (val, i) => {
    if (filter?.name === FieldNames.filterNamesWithCustomSetting.category || filter?.name === FieldNames.filterNamesWithCustomSetting.type) {
      let filterType = ""
      let postFireValues = []
      let fuelsValues = []
      if(filter?.name === FieldNames.filterNamesWithCustomSetting.category){
        postFireValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.postFire]?.[FieldNames.categoryAssociationFields.categories];
        fuelsValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.fuels]?.[FieldNames.categoryAssociationFields.categories];
        filterType = FieldNames.categoryAssociationFields.categories;
      } else if(filter?.name === FieldNames.filterNamesWithCustomSetting.type){
        postFireValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.postFire]?.[FieldNames.categoryAssociationFields.types];
        fuelsValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.fuels]?.[FieldNames.categoryAssociationFields.types];
        filterType = FieldNames.categoryAssociationFields.types;
      }

      if(filterType === FieldNames.categoryAssociationFields.types){
        let fuelsItemsForFiltering = [];
        let postFireItemsForFiltering = [];
        let finalPostFireItemsForFiltering = [];
        let finalFuelsItemsForFiltering = [];

        //Fuels
        fuelsCategories?.forEach((eaCategory) => {
          fuelsItemsForFiltering.push(actionCategoryAssociations?.[FieldNames.categoryAssociationFields.categories]?.[eaCategory]?.[FieldNames.categoryAssociationFields.types])
        })

        if(fuelsItemsForFiltering?.length){
          //Flatten the array so it's just 1 array and remove duplicates
          finalFuelsItemsForFiltering = [...new Set(fuelsItemsForFiltering.flat())]
        }

        if(finalFuelsItemsForFiltering?.length){
          //Only include the types that exist for the selected category
          fuelsValues = fuelsValues.filter(x => finalFuelsItemsForFiltering?.includes(x))
        }

        //Post Fire
        postFireCategories?.forEach((eaCategory) => {
          postFireItemsForFiltering.push(actionCategoryAssociations?.[FieldNames.categoryAssociationFields.categories]?.[eaCategory]?.[FieldNames.categoryAssociationFields.types])
        })

        if(postFireItemsForFiltering?.length){
          //Flatten the array so it's just 1 array and remove duplicates
          finalPostFireItemsForFiltering = [...new Set(postFireItemsForFiltering.flat())]
        }

        if(finalPostFireItemsForFiltering?.length){
          //Only include the types that exist for the selected category
          postFireValues = postFireValues.filter(x => finalPostFireItemsForFiltering?.includes(x))
        }
      }

      if ((dataSet === FieldNames.datasets.both && (fuelsValues?.length !== 0 || postFireValues?.length !== 0)) || 
          (dataSet === FieldNames.datasets.fuels && fuelsValues?.length !== 0) || (dataSet === FieldNames.datasets.postfire && postFireValues?.length !== 0)) {
        if ((fuelsValues?.includes(val.code) && !val.isPostFire && !isPostFire) || (postFireValues?.includes(val.code) && val.isPostFire && isPostFire)) {
          return (
            <FormControlLabel style={{ margin: '2px 0 2px 0', textWrap: 'wrap', textTransform: 'none', color: ColorConstants.TextDefault, height: 'auto', lineHeight: 1.5, letterSpacing: '0.00938em' }} key={i}
              control={
                <Checkbox style={{ padding: '0', margin: '0 5px 0 0px', borderColor: BlueAlien }} id={val.code} checked={val.isChecked} onClick={(e) => checkboxChanged(e, val)} />
              } label={val.name} />
          )
        } else {
          return;
        }
      } else {
        return (
          <FormControlLabel style={{ margin: '2px 0 2px 0', textWrap: 'wrap' }} key={i}
            control={
              <Checkbox style={{ padding: '0', margin: '0 5px 0 0px', borderColor: BlueAlien }} id={val.code} checked={val.isChecked} onClick={(e) => checkboxChanged(e, val)} />
            } label={val.name} />
        )
      }
    } else {
      return (
        <FormControlLabel style={{ margin: '2px 0 2px 0', textWrap: 'wrap' }} key={i}
          control={
            <Checkbox style={{ padding: '0', margin: '0 5px 0 0px', borderColor: BlueAlien }} id={val.code} checked={val.isChecked} onClick={(e) => checkboxChanged(e, val)} />
          } label={val.name} />
      )
    }
  }

  return (
    <FormGroup style={{ padding: '10px 4px 10px 10px' }}>
      {filterValues.map((val, i) => (
        filterCheckboxes(val, i)
      ))}
    </FormGroup>
  )
}